import React from 'react';
import { useInView } from './useParallax';
import { Mandala, DiamondDivider, OmGlyph } from './svgs';
import './About.css';

function StatCard({ number, label }) {
  const [ref, inView] = useInView(0.3);
  return (
    <div ref={ref} className={`about__stat ${inView ? 'about__stat--visible' : ''}`}>
      <span className="about__stat-num cinzel">{number}</span>
      <span className="about__stat-label">{label}</span>
    </div>
  );
}

export default function About() {
  const [ref, inView] = useInView(0.15);

  return (
    <section className="about" id="about" ref={ref}>
      <div className="about__mandala-bg">
        <Mandala size={500} opacity={0.05} />
      </div>

      <div className="section-container">
        <div className={`about__header ${inView ? 'about__header--visible' : ''}`}>
          <OmGlyph size={48} color="#C9902A" />
          <p className="about__eyebrow cinzel">About the Ashram</p>
          <h2 className="about__title cinzel">
            Vedanagari — <span className="about__title-accent">City of the Vedas</span>
          </h2>
          <DiamondDivider color="#C9902A" />
        </div>

        <div className={`about__grid ${inView ? 'about__grid--visible' : ''}`}>
          <div className="about__text-block">
            <p>
              Vedanagari Ashram is an open spiritual platform nestled at the sacred foot of
              <strong> Arunachala</strong>, the hill of fire revered as the physical manifestation of Lord Shiva.
              We welcome all seekers — renunciants, pilgrims, devotees, and the simply curious — to
              discover the transformative power of Vedic wisdom.
            </p>
            <p>
              Our mission is threefold: to preserve and share ancient Vedic knowledge through
              authentic rituals and teachings; to serve the sadhus, elders, and pilgrims who
              walk the sacred path; and to build a living community rooted in devotion,
              simplicity, and compassion.
            </p>
            <p>
              The ashram sits along the <em>Girivalam</em> circumambulation path — the 14 km
              pradakshina around Arunachala — offering meals, rest, and spiritual nourishment
              to countless seekers who walk this ancient circuit, especially on full-moon nights.
            </p>
          </div>

          <div className="about__pillars">
            <div className="about__pillar">
              <span className="about__pillar-icon devanagari">ज्ञान</span>
              <h3 className="cinzel">Jnana</h3>
              <p>Vedic knowledge, teachings, and the sacred fire of inquiry into the Self.</p>
            </div>
            <div className="about__pillar">
              <span className="about__pillar-icon devanagari">भक्ति</span>
              <h3 className="cinzel">Bhakti</h3>
              <p>Devotion through prayer, puja, homam, and surrender to the Divine.</p>
            </div>
            <div className="about__pillar">
              <span className="about__pillar-icon devanagari">सेवा</span>
              <h3 className="cinzel">Seva</h3>
              <p>Selfless service — feeding pilgrims, supporting sadhus, uplifting souls.</p>
            </div>
          </div>
        </div>

        <div className="about__stats">
          <StatCard number="24/7" label="Prasadam Service" />
          <StatCard number="1000s" label="Pilgrims Served Monthly" />
          <StatCard number="∞" label="Hearts Touched" />
          <StatCard number="1" label="Sacred Mountain" />
        </div>
      </div>
    </section>
  );
}
